"use strict";

var _interopRequireWildcard = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var echarts = _interopRequireWildcard(require("echarts"));
//
//
//
//

require("echarts/theme/macarons"); // echarts theme
// import resize from './mixins/resize'

var animationDuration = 6000;
// import {monthNum} from '../../api/charts.js'
var _default = exports.default = {
  //   mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "50%"
    },
    height: {
      type: String,
      default: "500px"
    },
    productArr: {
      type: Array
      // default: []
    }
    // month: {
    //     type: Object,
    //     default: () => {
    //         return {}
    //     }
    // }
  },
  watch: {
    productArr: {
      //深度监听，可监听到对象、数组的变化
      handler: function handler(val, oldVal) {
        var _this = this;
        var productList = [];
        var countList = [];
        var date = new Date();
        val.map(function (item) {
          productList.push(item.productNo);
          countList.push(item.exchangeRate);
          _this.chart.setOption({
            tooltip: {
              trigger: "item",
              formatter: "{c}%" //这是关键，在需要的地方加上就行了
            },
            title: {
              text: "换货率",
              textStyle: {
                color: "#6bc0dc"
              },
              left: "20px"
            },
            xAxis: [{
              type: "category",
              data: productList,
              axisLabel: {
                interval: 0,
                rotate: 30
              }
            }],
            yAxis: [{
              type: "value",
              axisTick: {
                show: false
              },
              axisLabel: {
                show: true,
                interval: "auto",
                formatter: "{value} %"
              }
            }],
            series: [{
              type: "bar",
              barWidth: "40%",
              data: countList,
              animationDuration: animationDuration,
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    //开启显示
                    position: "top" //在上方显示
                  },
                  color: "#6bc0dc"
                }
              }
            }]
          });
        });
      },
      deep: true //true 深度监听
    }
  },
  data: function data() {
    return {
      chart: null,
      form: {
        dealer: "",
        year: ""
      }
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    this.$nextTick(function () {
      _this2.initChart();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      var _this3 = this;
      this.chart = echarts.init(this.$el);
      var productList = [];
      var countList = [];
      this.productArr.map(function (item) {
        productList.push(item.productNo);
        countList.push(item.exchangeRate);
        _this3.chart.setOption({
          title: {
            text: "换货率",
            textStyle: {
              color: "#6bc0dc"
            },
            left: "20px"
          },
          tooltip: {
            trigger: "item",
            formatter: "{c}%" //这是关键，在需要的地方加上就行了
          },
          xAxis: [{
            type: "category",
            data: productList,
            axisLabel: {
              interval: 0,
              rotate: 30
            }
          }],
          yAxis: [{
            type: "value",
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              interval: "auto",
              formatter: "{value} %"
            }
          }],
          series: [{
            //   name: 'pageA',
            type: "bar",
            //   stack: 'vistors',
            barWidth: "40%",
            data: countList,
            animationDuration: animationDuration,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  //开启显示
                  position: "top" //在上方显示
                },
                color: "#6bc0dc"
              }
            }
          }]
        });
      });
      // })
    }
  }
};